import { render, staticRenderFns } from "./ProjectRole.vue?vue&type=template&id=37785db8"
import script from "./ProjectRole.vue?vue&type=script&lang=js"
export * from "./ProjectRole.vue?vue&type=script&lang=js"
import style0 from "./ProjectRole.vue?vue&type=style&index=0&id=37785db8&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports